import React, { useEffect, useState } from 'react';
import { SelectTW } from '../SelectTW';
import '../filterComponents.css';

const SelectFilterTW = ({
    type,
    label,
    filterKey,
    deletable,
    options = [],
    onFilterChange,
    currentValue,
    multiple = false,
    placeholder = 'Select...',
    loading = false,
    searchable = false,
}) => {
    // Convert options from strings to {value, label} format
    const formattedOptions = options.map((opt) => ({
        value: opt,
        label: opt,
    }));

    // Extract values from filter format
    const getValue = () => {
        if (!currentValue) return null;

        if (multiple) {
            return Array.isArray(currentValue) ? currentValue.map((v) => v.data) : [];
        } else {
            return currentValue.data;
        }
    };

    // Handle change and format for the filter system
    const handleChange = (value) => {
        if (value === null) {
            onFilterChange(null);
            return;
        }

        if (multiple) {
            onFilterChange(
                value.map((val) => ({
                    type,
                    data: val,
                    chipLabel: `${label}: ${val}`,
                    filterKey,
                    deletable,
                }))
            );
        } else {
            onFilterChange({
                type,
                data: value,
                chipLabel: `${label}: ${value}`,
                filterKey,
                deletable,
            });
        }
    };

    return (
        <SelectTW
            options={formattedOptions}
            value={getValue()}
            onChange={handleChange}
            placeholder={placeholder}
            multiple={multiple}
            loading={loading}
            searchable={searchable}
        />
    );
};

export { SelectFilterTW };
